import React from 'react';
import { Check, X } from 'lucide-react';

const ComparisonTable = () => {
  const comparisons = [
    { feature: 'Trading Hours', xstocks: '24/7', traditional: 'Market Hours Only', xstocksWin: true },
    { feature: 'Settlement Time', xstocks: '3-5 seconds', traditional: 'T+2 (2 days)', xstocksWin: true },
    { feature: 'Transaction Fees', xstocks: '<$0.01', traditional: '$5-15+', xstocksWin: true },
    { feature: 'Self-Custody', xstocks: true, traditional: false, xstocksWin: true },
    { feature: 'Cross-Border Access', xstocks: true, traditional: false, xstocksWin: true },
    { feature: 'DeFi Compatible', xstocks: true, traditional: false, xstocksWin: true },
  ];

  return (
    <section className="py-24 bg-[#0b0014] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-1/2 left-0 w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-[150px] -translate-y-1/2" />
      <div className="absolute top-1/2 right-0 w-[400px] h-[400px] bg-indigo-600/10 rounded-full blur-[120px] -translate-y-1/2" />
      
      <div className="max-w-[1000px] mx-auto px-6 relative">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center mb-4">
          No more waiting days for trades to clear
        </h2>
        <p className="text-xl text-gray-400 text-center mb-12">
          with <span className="text-purple-400 font-semibold">Stocks Protocol</span>
        </p>
        
        {/* Comparison Table */}
        <div className="bg-white/[0.02] border border-white/[0.08] rounded-2xl overflow-hidden backdrop-blur-sm">
          {/* Header */}
          <div className="grid grid-cols-3 bg-white/[0.03]">
            <div className="p-3 md:p-5 border-r border-white/[0.06]">
              <span className="text-gray-500 font-medium text-xs md:text-base">Feature</span>
            </div>
            <div className="p-3 md:p-5 border-r border-white/[0.06] text-center">
              <span className="text-purple-400 font-semibold text-xs md:text-lg">Stocks Protocol</span>
            </div>
            <div className="p-3 md:p-5 text-center">
              <span className="text-gray-400 font-medium text-xs md:text-base">Traditional</span>
            </div>
          </div>
          
          {/* Rows */}
          {comparisons.map((row, index) => (
            <div 
              key={index}
              className="grid grid-cols-3 border-t border-white/[0.06] hover:bg-white/[0.02] transition-colors"
            >
              <div className="p-3 md:p-5 border-r border-white/[0.06] flex items-center">
                <span className="text-white font-medium text-xs md:text-base">{row.feature}</span>
              </div>
              <div className="p-3 md:p-5 border-r border-white/[0.06] flex items-center justify-center">
                {typeof row.xstocks === 'boolean' ? (
                  row.xstocks ? (
                    <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-green-500/20 flex items-center justify-center">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-green-400" />
                    </div>
                  ) : (
                    <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-red-500/20 flex items-center justify-center">
                      <X className="w-4 h-4 md:w-5 md:h-5 text-red-400" />
                    </div>
                  )
                ) : (
                  <span className="text-green-400 font-semibold text-xs md:text-base">{row.xstocks}</span>
                )}
              </div>
              <div className="p-3 md:p-5 flex items-center justify-center">
                {typeof row.traditional === 'boolean' ? (
                  row.traditional ? (
                    <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-green-500/20 flex items-center justify-center">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-green-400" />
                    </div>
                  ) : (
                    <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-red-500/20 flex items-center justify-center">
                      <X className="w-4 h-4 md:w-5 md:h-5 text-red-400" />
                    </div>
                  )
                ) : (
                  <span className="text-gray-400 text-xs md:text-base">{row.traditional}</span>
                )}
              </div>
            </div>
          ))}
        </div>
        
        <p className="text-sm text-gray-600 text-center mt-6">
          * Built on Stellar and XRPL for maximum efficiency and minimal fees.
        </p>
      </div>
    </section>
  );
};

export default ComparisonTable;
